'use strict';

module.exports = {
    'lang': 'zh-cn',
    'resetSettings': '还原设置',
    'include': '包含',
    'exclusive': '不包含',
    'equal': '等于',
    'unequal': '不等于',
    'begin': '以开始',
    'end': '以结尾',
    'greater_than': '大于',
    'great_than_equal_to': '大于等于',
    'less_than': '小于',
    'less_than_equal_to': '小于等于',
    'be_equal_to': '等于',
    'not_equal_to': '不等于',
    "no_data": '暂无数据',
    "bool_true": "是",
    "bool_false": "否",
    'en-us': {
        'resetSettings': 'Reset',
        'include': 'Include',
        'exclusive': 'Not include',
        'equal': 'Equal to',
        'unequal': 'Not equal to',
        'begin': 'Begin with',
        'end': 'End with',
        'greater_than': 'Greater than',
        'great_than_equal_to': 'Greater than or equal to',
        'less_than': 'Less than',
        'less_than_equal_to': 'Less than or equal to',
        'be_equal_to': 'Equal to',
        'not_equal_to': 'Not equal to',
        "no_data": 'No data',
        "bool_true": "true",
        "bool_false": "false"
    },
    'zh-tw': {
        'resetSettings': '還原設置',
        'include': '包含',
        'exclusive': '不包含',
        'equal': '等於',
        'unequal': '不等於',
        'begin': '以開始',
        'end': '以結尾',
        'greater_than': '大於',
        'great_than_equal_to': '大於等於',
        'less_than': '小於',
        'less_than_equal to': '小於等於',
        'be_equal_to': '等於',
        'not_equal_to': '不等於',
        "no_data": '暫無數據',
        "bool_true": "是",
        "bool_false": "否"
    }
};